// extracted by mini-css-extract-plugin
module.exports = {"SystemContainer":"System-module--SystemContainer--38ZQW","Subtext":"System-module--Subtext--WVBMF"};